import * as React from "react";
import Input from "../../Input-new/Input";
import UploadFiles from "./UploadFiles"
import RepAgreementForm from "./RepAgreementForm";
import RepAmendmentForm from "./RepAmendmentForm";
import { isFieldLocked } from "../../../access-levels";

const items=[{
        label:'Rep Agreement',
        name:'REP_AGREEMENT_FILE_1'
        },{
        label:'Additional File 1',
        name:'REP_AGREEMENT_FILE_2'
        },{
        label:'Additional File 2',
        name:'REP_AGREEMENT_FILE_3'
        },{
        label:'Additional File 3',
        name:'REP_AGREEMENT_FILE_4'
        },{
        label:'Additional File 4',
        name:'REP_AGREEMENT_FILE_5'
        }];

const RepresentationAgreement = ({data, handleChangeInput, handleChangeFile, viewMode, deleted, locks}) => {
    return (
        <div className="Rep-agreement">
            <div className="Rep-agreement_column">
                <Input
                    className="Rep-agreement_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="LISTED_DATE"
                    label="Date Listed"
                    value={data.LISTED_DATE}
                    disabled={isFieldLocked(locks, "LISTED_DATE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    type="text"
                    valueType="number"
                    name="EXPIRATION_NO_OF_MONTHS"
                    label="# Of Months"
                    value={data.EXPIRATION_NO_OF_MONTHS}
                    disabled={isFieldLocked(locks, "EXPIRATION_NO_OF_MONTHS")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    placeholder="MM/DD/YYYY"
                    type="text"
                    valueType="date"
                    name="EXPIRATION_DATE"
                    label="Listing Expiration Date"
                    value={data.EXPIRATION_DATE}
                    disabled={isFieldLocked(locks, "EXPIRATION_DATE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                />
                <Input
                    className="Rep-agreement_column_item"
                    type="text"
                    valueType="percent"
                    name="SELLER_FEE_PERCENTAGE"
                    label="Fee Percentage"
                    value={data.SELLER_FEE_PERCENTAGE}
                    disabled={isFieldLocked(locks, "SELLER_FEE_PERCENTAGE")}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    isDollar
                />
                <Input
                    className="Rep-agreement_column_item"
                    disabled
                    type="text"
                    valueType="float"
                    name="TOTAL_FEE"
                    label="Total Fee - Auto"
                    value={data.TOTAL_FEE}
                    handleParentChange={handleChangeInput}
                    viewMode={viewMode}
                    deleted={deleted}
                    decimals={2}
                    isDollar
                />
            </div>
            <div className="Rep-agreement_column">
                <UploadFiles 
                    classNames="Rep-agreement_column_item"
                    data={data}
                    viewMode={viewMode} 
                    deleted={deleted}
                    handleChangeFile={handleChangeFile}
                    maxFilesAmount={items.length}
                    items={items}
                    droppable
                    />
                <div style={{ marginTop: 'auto' }}>
                    <RepAgreementForm
                        data={data}
                        handleChangeInput={handleChangeInput}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                    <RepAmendmentForm
                        data={data}
                        viewMode={viewMode}
                        deleted={deleted}
                    />
                </div>
            </div>
        </div>
    );
};

export default RepresentationAgreement;
